import {ScoringMethod} from "./scoring-method";
import {HandicapMode} from "../../model/round";

export interface ParticipantTotalScore {
    method: ScoringMethod,
    handicapMode: HandicapMode,
    score: TotalScore
}

export interface TotalScore {
    type: TotalScoreType
}

export enum TotalScoreType {
    StrokePlayScore = "StrokePlayScore",
    StablefordScore = "StablefordScore",
    Unavailable = "Unavailable"
}

export interface StrokePlayTotalScore extends TotalScore {
    value: number | null
    relativeToPar: number | null
}

export interface StablefordTotalScore extends TotalScore {
    points: number | null
}
